<template>
  <div class="qw-table-panel">
    <div v-if="title || $slots.extra" class="qw-table-panel__header">
      <span v-if="title" class="qw-table-panel__title">{{ title }}</span>
      <div v-if="$slots.extra" class="qw-table-panel__extra">
        <slot name="extra" />
      </div>
    </div>
    <div class="qw-table-panel__body">
      <slot />
    </div>
  </div>
</template>

<script>
// 表格卡片面板：统一表格容器的圆角/边框/表头样式
// 视觉全部由全局 layout.scss / business-page-theme.scss 的 .qw-table-panel 体系接管
export default {
    name: 'TablePanel',
    props: {
        title: { type: String, default: '' }
    }
}
</script>
